export default {
      id: "ic_pre_bulletin_live_red-usage",
      viewBox: "0 0 40 30",
      url: "/" + "images/icons.3.109.2.svg#ic_pre_bulletin_live_red-usage",
      toString: function () {
        return this.url;
      }
    }